import { Association } from '../../../shared/models/association.model';
import { AssociationService } from '../../../shared/services/association.service';
import { LoaderService } from '../../../shared/services/loader.service';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class AssociationsListResolver implements Resolve<Association[]> {

  constructor( @Inject(AssociationService) private service: AssociationService,
    @Inject(LoaderService) private loaderService: LoaderService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Association[]> {
    this.loaderService.show();
    return this.service.list();
  }
}
